<template>
  <div class="menu-border">
    <vidi-menu :menu-list="menuHeadList" :checkedMenu="checkedMenu" :first-menu-name="firstMenuName"></vidi-menu>

    <!-- sale channel 区域-->
    <div class="sale-channel" v-if="menuMiddleFlag">
      <el-divider></el-divider>
      <p>Sales Channel</p>
      <vidi-menu  :menu-list="menuMiddleList" :checkedMenu="checkedMenu" :first-menu-name="firstMenuName"></vidi-menu>
    </div>

    <!-- 底部区域 -->
    <div class="menu-bottom" >
      <el-divider></el-divider>
      <vidi-menu  :menu-list="menuFixtedList" :checkedMenu="checkedMenu" :first-menu-name="firstMenuName"></vidi-menu>
    </div>


  </div>
</template>

<script>
import VidiMenu from "./vidi-menu";
export default {
  components: {VidiMenu},
  props: {
    // 选中的菜单，用来加粗加下划线显示
    checkedMenu: {
      type: String,
      default: ''
    },
    // 选中的一级菜单，选中则显示对应2级菜单
    firstMenuName: {
      type: String,
      default: ''
    },
    menuList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    menuList: {
      handler(n, o) {
        this.menuHeadList = n.filter(f => !this.nonNeedHeadList.includes(f['name']))
        this.menuMiddleList = n.filter(f => f['name'] == 'Marketplace' || f['name'] == 'ViDirect')
        this.menuFixtedList = n.filter(f => f.name === 'Account Settings' || f.name === 'Help Center')

        this.menuMiddleFlag = true
        if (!this.menuMiddleList || this.menuMiddleList.length == 0) {
          this.menuMiddleFlag = false
        }


      },
      deep: true
    }
  },
  data() {
    return {
      nonNeedHeadList:['Marketplace','ViDirect','Account Settings','Help Center'],
      menuHeadList: [],
      menuMiddleList: [],
      menuFixtedList:[],
      menuMiddleFlag: true

    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>

.menu-border {
  height: calc(100vh - 90px);
  width: 100%;
  padding: 30px 10px 0px 10px;
  user-select: none;
  white-space:nowrap;
  position: relative;
}

.sale-channel{
  .el-divider{width: 100% !important;}
  margin-top: 15px;
  width: 100%;
  p{
    padding-left: 20px;
  }
  p:nth-child(2){
    margin-top: 5px;
    margin-bottom: 5px;
    color: #8F8F8F;
    font-size: 12px;
  }
}
.menu-bottom{
  width: 90%;
  .el-divider {
    width: 100% !important;
    margin-bottom: 5px !important;
  }
  position: absolute;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/left-menu.vue